import { ContactRelationRow } from "services/api/contacts/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";

export const CONTACT_REPRESENTATIVE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handlePersonClick: (id: string) => void,
  handleDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void,
): Column[] => [
  {
    title: "",
    key: "representative_person",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      const initials = `${row.personContact?.firstName?.charAt(0) ?? ""}${row.personContact?.lastName?.charAt(0) ?? ""}`;
      const imageUrl = row.personContact?.pictures?.[0]?.url ?? null;
      return (
        <div
          className="inline-flex gap-3 items-center text-md font-medium truncate text-sky-600 hover:text-sky-900 text-sm cursor-pointer"
          onClick={() => row.personContact?.id && handlePersonClick(row.personContact.id)}>
          <TableIcon imageUrl={imageUrl} initials={initials} />
          <span>{row.personContact?.firstName} {row.personContact?.lastName}</span>
        </div>
      );
    },
  },
    {
    title: "Grupa",
    key: "representative_groups",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      const groups = row.personContact?.contactGroups ?? [];
      return <span className="text-sm text-slate-600">{groups.length > 0 ? groups.map(g => g.name).join(", ") : "-"}</span>;
    },
  },
  {
    title: "Funkcija",
    key: "representative_job",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return <span className="text-sm text-slate-600">{row.personContact?.jobTitle ?? "-"}</span>;
    },
  },
  {
    title: "Odjel",
    key: "representative_department",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return <span className="text-sm text-slate-600">{row.personContact?.department ?? "-"}</span>;
    },
  },
  {
    title: "Email",
    key: "representative_email",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return <span className="text-sm text-slate-600">{row.personContact?.primaryContactEmail?.emailAddress ?? "-"}</span>;
    },
  },
  {
    title: "Telefon",
    key: "representative_phone",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return <span className="text-sm text-slate-600">{row.personContact?.primaryContactPhone?.phoneNumber ?? "-"}</span>;
    },
  },
  {
    title: "Adresa",
    key: "representative_address",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return <span className="text-sm text-slate-600">{row.personContact?.primaryContactAddress?.line1 ?? "-"}</span>;
    },
  },
  {
    title: "Grupa",
    key: "representative_groups",
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      const groups = row.personContact?.contactGroups ?? [];
      return <span className="text-sm text-slate-600">{groups.length > 0 ? groups.map(g => g.name).join(", ") : "-"}</span>;
    },
  },
  {
    title: "",
    key: "representative_actions",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: ContactRelationRow) => {
      return (
        <ButtonMenu endIcon="/media/icons/more-dots.svg" variant="text">
          <ButtonMenuItem
            startIcon="/media/icons/trash.svg"
            variant="remove"
            onClick={(e: any) => handleDeleteClick(e, row.id)}
          >
            {t("admin.contacts.contact.detail.representative.delete")}
          </ButtonMenuItem>
        </ButtonMenu>
      );
    },
  },
];
